import { ButtonV2, styled } from '@withjoy/joykit';
import { buttonSharedStates } from '@shared/utils/style/buttons';

export const StyledActionButton = styled(ButtonV2)`
  ${buttonSharedStates};
`;
